/* global ajaxurl TimelineMax Power1 */

(function($) {
    $(window).load(function() {
        $('.wid-osw').ostatnieWyniki();
    });
    
    $.fn.ostatnieWyniki = function(opt) {
        var o, settings;
        var pr = null, ne = null;
        if ( typeof opt === 'object') o = opt; else o = {};
        settings = $.extend({
            ftime: 5000,
            stime: 9000
        }, o );
    
        return this.each(function() {
            var me = $(this);
            me.animated = false;
            me.init = function() {
                var me = this;
                pr = me.find('.prev');
                ne = me.find('.next');
                pr.click(function() {
                    if (me.animated) return;
                    me.prev();
                });
                ne.click(function() {
                    if (me.animated) return;
                    me.next();
                });
                $.ajax(ajaxurl + '?action=getLatestResults', {
                    success: function(r) { 
                        if ( typeof r !== 'object' || !r.success )
                            return;
                        me.find('.inner').append(r.content);
                        me.ul = me.find('ul');
                        me.removeClass('invisible').addClass('visible');
                        me.resize();
                        $(document).on('changeBreakpoint', function() {
                            me.resize();
                        });
                    }}
                );
            };
            me.prev = function(t) {
                var me = this;
                if (me.animated) return;
                me.animated = true;
                var liFirst = me.ul.find('li:first'),
                    liLast = me.ul.find("li:last"),
                    cl = liLast.clone(),
                    tla = new TimelineMax();
                clearTimeout(me.timer);
                liFirst.before(cl);
                me.ul.css({left: (-cl.outerWidth()) + 'px'});
                tla.to(me.ul, 1, { left: 0, ease: Power1.easeInOut })
                        .call(function() {
                            liLast.remove();
                            if (settings.stime) {
                                me.timer = setTimeout(function() { me.next(); }, settings.stime);    
                            }
                            me.animated = false;
                        });
            };
            me.next = function(t) {
                var me = this;
                me.animated = true;
                clearTimeout(me.timer);
                var liFirst = me.ul.find('li:first'),
                    tla = new TimelineMax();
                me.ul.find("li:last").after(liFirst.clone().css({opacity: 1}));
                    tla.to(me.ul, 1, { left: -liFirst.outerWidth(), ease: Power1.easeInOut })
                        .to(liFirst, 1, {opacity: 0}, '-=1')
                        .call(function() {
                            liFirst.remove();
                            me.ul.css({left: 0});
                            if (settings.stime) {
                                me.timer = setTimeout(function() { me.next(); }, settings.stime);    
                            }
                            me.animated = false;
                        });
            };
            me.resize = function() {
                var me = this, inner = me.find('.inner'), li = me.find('li');
                me.removeClass('visible').addClass('invisible');
                var cw = inner.width(), ulw = 0;
                li.each(function() {
                    ulw += $(this).outerWidth();
                });
                if ( cw < ulw ) {
                    window.clearTimeout(me.timer);
                    me.timer = setTimeout(function() { me.next(); }, settings.ftime);
                } 
                me.removeClass('invisible').addClass('visible');
            };
            
            me.init();
            return me;
        });
    };
})(jQuery);
